import React from 'react'
import PropTypes from 'prop-types'
import { t } from 'translation'

const AlarmModalSongItem = ({
  artist,
  genreName,
  title,
  selectSongHandler,
  selected,
  imageUrl,
}) => (
  <li className="alarm_block_list_item">
    <button className="alarm_block preview_mod song_btn_mod" onClick={selectSongHandler}>
      <div className="alarm_block_w_img">
        <img
          className="alarm_block_img"
          src={imageUrl}
          alt={`${title} ${t('alarm.BY')} ${artist}`}
        />
      </div>
      <div className={`alarm_block_descr ${selected ? 'selected' : ''}`}>
        <div className="alarm_block_category">{genreName.toUpperCase()}</div>
        <div className="alarm_block_name">{title}</div>
        <div className="alarm_block_artist">{artist}</div>
      </div>
    </button>
  </li>
)

export default AlarmModalSongItem

AlarmModalSongItem.propTypes = {
  artist: PropTypes.string.isRequired,
  genreName: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  selectSongHandler: PropTypes.func.isRequired,
}
